const phoneTransform = (phoneNum) =>
  `(${phoneNum.slice(0, 3)}) ${phoneNum.slice(3, 6)}-${phoneNum.slice(6)}`

export default phoneTransform
